<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{on, attrs}">
      <v-btn color="dialogBtn" dark class="mb-2 red--text text--accent-4" rounded v-bind="attrs" v-on="on">Add new</v-btn>
    </template>
    <v-card>

      <v-toolbar color="secondary" class="mb-5">
        <v-toolbar-title class="headline">New Medication</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-autocomplete
            ref="medications"
            :items="medicationList"
            label="Medications"
            prepend-icon="mdi-prescription"
            item-value="id"
            :rules="[rules.required]"
            item-text="medication"
            v-model="medication.medication_id"
            outlined
            dense
            rounded
          ></v-autocomplete>
          <v-spacer></v-spacer>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary darken-1" rounded @click="save">Save</v-btn>
        <v-btn color="secondary darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    dialog: false,
    valid: true,
    medication: {
      medication_id: ""
    },
    medicationList:[],
    rules: {
      required: v => !!v || 'This field is required!'
    }
  }),
  created() {
    this.$store.dispatch("medications/aList");
    this.clearForm();
  },
  computed: {
    ...mapGetters("medications", {
      medications: "gList"
    })
  },
  watch: {
    medications(meds) {
      //console.log(meds)
      var list = [];
      meds.forEach(val => {
        var med = val.medication + " (" + val.presentation + ")";
        list.push({id: val.id, medication: med})
      })
      this.medicationList = Object.assign(this.medicationList, list);
    } 
  },
  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("medications/aAdd", this.medication).then(res => {
          if (res) {
            this.clearForm()
            this.dialog = false;
          }
        });
      }
    },
    clearForm() {
      this.medication.medication_id = '';
    },
    medAndForum(med) {
      console.log(med)
      return med;
    }
  }
};
</script>

<style>
</style>